const arsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatClienteBalance(value) {
  return arsFormatter.format(Number(value) || 0);
}

export function formatClienteCuit(value) {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length !== 11) return value || '—';
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
}

export function formatClienteDate(value) {
  if (!value) return '—';
  const text = String(value);
  const calendarDate = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (calendarDate) return `${calendarDate[3]}-${calendarDate[2]}-${calendarDate[1]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
}
